<template>
  <div class="home">
    <div class="top">
      <div class="left">
        <div class="block left-top">
          <div class="title">订单信息</div>
        </div>
        <div class="lineRow"></div>
        <div class="block left-bottom">
          <div class="title">销售统计</div>
          <div class="echarts">
            <ECharts :options="LineChartOption" autoresize />
          </div>
        </div>
      </div>
      <div class="lineBlock"></div>
      <div class="top-right block">
        <div class="title">产品统计</div>
         <div class="echarts">
          <ECharts :options="pieEchartsOption" autoresize />
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="block left">
        <div class="title">销售统计</div>
      </div>
      <div class="lineBlock"></div>
      <div class="block right">
        <div class="title">销售统计</div>
      </div>
    </div>
  </div>
</template>

<script>
import { LineChartOption, pieEchartsOption } from './echarts.options';
import 'echarts';
import ECharts from 'vue-echarts'

  export default {
    name: 'home',
    components: { ECharts },
    data() {
      return {
        LineChartOption,
        pieEchartsOption
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
.echarts {
  width: 100%;
  height: calc(100% - 20px);
}
.home {
  display: flex;
  flex-direction: column;
}
.top {
  flex-basis: 28vw;
  display: flex;
  height: 28vw;
  margin-bottom: 1.7vw;
  .lineBlock {
    width: 1.7vw;
  }
  .lineRow {
    height: 1.5vw;
  }
  .left {
    flex: 1;
    display: flex;
    flex-direction: column;
    .block {
      flex: 1;
      position: relative;
      overflow: hidden;
    }
    .left-top {
      flex: none;
      height: 5vw;
    }
    .left-bottom {
      height: 22vw;
      max-height: 22vw;
    }
  }
  .right {
    flex-basis: 26vw;
    width: 26vw;

  }
  .top-right {
    max-height: 28vw;
    height: 28vw;
    flex-basis: 26vw;
    width: 26vw;
  }
}

.bottom {
  display: flex;
  flex: 1;
  .left {
    flex: 1;
  }
  .lineBlock {
    flex-basis: 2vw;
  }
  .right {
    flex: 1;
  }
}

.block {
  background: #fff;
  .title {
    display: flex;
    padding-left: 0.7vw;
    margin-top: 0.8vw;
    margin-left: 1vw;
    position: relative;
    &::before {
      content: " ";
      position: absolute;
      left: 0;
      background: #0a65ca;
      height: 1.3vw;
      width: 0.4vw;
    }
  }
}
</style>